// extracted by mini-css-extract-plugin
export default {"wrapper":"S4","in_view":"T4","in_view_scrolled":"U4","img":"V4","content":"W4","icons":"X4","icon":"Y4","text_wrapper":"Z4"};
    if(module.hot) {
      // 1715276860142
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  